import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PhoneCall } from 'lucide-react';

import { useOnboardingStore } from '@/lib/stores/onboarding';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export const Route = createFileRoute('/onboarding/voice')({
  component: VoiceStep,
});

function VoiceStep() {
  const { t } = useTranslation('onboarding');
  const navigate = useNavigate();
  const store = useOnboardingStore();

  function goBack() {
    store.setStep('services');
    void navigate({ to: '/onboarding/services' });
  }

  function finish() {
    const finalState = {
      identity:          store.identity,
      banking:           store.banking,
      services:          store.services,
      gdprConsentVersion: store.gdprConsentVersion,
      gdprConsentAt:     store.gdprConsentAt,
      submittedAt:       new Date().toISOString(),
    };

    // TODO: replace with API call POST /onboarding/complete
    console.log('[TradeCraft] Onboarding complete:', JSON.stringify(finalState, null, 2));

    void navigate({ to: '/' });
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="mb-6">
          <h2 className="font-display text-display-sm text-forge">{t('voice.heading')}</h2>
          <p className="text-sm text-steel mt-1">{t('voice.subheading')}</p>
        </div>

        <div className="rounded-lg bg-parchment border border-linen p-6 flex flex-col items-center gap-4 text-center my-6">
          <div className="h-14 w-14 rounded-full bg-copper/10 flex items-center justify-center">
            <PhoneCall className="h-7 w-7 text-copper" />
          </div>
          <p className="text-sm text-iron max-w-sm">{t('voice.placeholder')}</p>
          <p className="text-xs text-steel">{t('voice.finish_note')}</p>
        </div>

        <div className="rounded-lg bg-moss/10 border border-moss/30 px-4 py-3 text-center">
          <p className="text-sm font-medium text-moss">{t('voice.trial_info')}</p>
        </div>

        <div className="flex justify-between pt-6">
          <Button type="button" variant="ghost" onClick={goBack}>
            {t('actions.back', { ns: 'common' })}
          </Button>
          <Button type="button" variant="primary" size="lg" onClick={finish}>
            {t('actions.finish', { ns: 'common' })}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
